// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m1JZ","label":"styles_label__1dIs2"};